import type { SetupStatus } from '@mervonn/shared-types';

/**
 * D4 — the dashboard shows the setup layout only to an admin (`tenant.edit`) of a
 * tenant that has never produced attendance, and only while no terminal has ever
 * connected or there are no active employees.
 */
export function showSetupDashboard(s: SetupStatus | undefined): boolean {
  if (!s || !s.can_edit || s.has_attendance_history) return false;
  const terminal = s.steps.find((x) => x.key === 'terminal');
  const employees = s.steps.find((x) => x.key === 'employees');
  const neverConnected = !terminal || terminal.state === 'none' || terminal.state === 'never_connected';
  const noEmployees = !employees || (employees.count ?? 0) === 0;
  return neverConnected || noEmployees;
}

/**
 * The sidebar's setup-progress card. Established tenants (any attendance history) and
 * tenants that can never finish a step — e.g. one admin and the "2 payroll approvers"
 * step — must not be nagged, so history switches it off for good.
 */
export function showSetupCard(s: SetupStatus | undefined): boolean {
  return !!s && !s.complete && !s.has_attendance_history && s.can_edit;
}
